import request from '@/utils/request'

/**
 * 查询账户保证金信息
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryAccountBond(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.queryAccountBond',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺类型
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShopType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存账户保证金信息
 * @param {Object} data 保存数据
 * @returns {Promise} 返回Promise对象
 */
export function saveAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.saveAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新账户保证金信息
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export function updateAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.updateAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除账户保证金信息
 * @param {Object} data 删除数据
 * @returns {Promise} 返回Promise对象
 */
export function deleteAccountBond(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBond.deleteAccountBond',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}